<template>
  <v-dialog v-model="dialog" max-width="820" :retain-focus="false" persistent>
    <v-card class="dialog-card" elevation="6">
      <v-card-title class="pb-1 align-center">
        <v-icon left color="primary" class="mr-2">mdi-filter</v-icon>
        <div class="d-flex flex-column">
          <span class="title">Filtrar solicitudes</span>
          <small class="muted">Limita la lista por programa, módulo, estado o rango de fechas</small>
        </div>
      </v-card-title>
      <v-card-text class="pt-2">
        <v-divider class="mt-1"></v-divider>
        <v-row dense>

          <v-col cols="12" md="6" lg="4">
            <v-select
              v-model="form.gestion"
              :items="gestionesOptions"
              label="Gestión"
              dense
              outlined
              hide-details
              clearable />
            <small class="field-note">Selecciona el año de gestión.</small>
          </v-col>

          <v-col cols="12">
            <v-autocomplete
              v-model="form.programaId"
              :items="programas"
              item-text="nombre"
              item-value="id"
              label="Programa"
              dense
              outlined
              hide-details
              clearable
              :loading="cargandoProgramas"
              @change="onProgramaChange" />
            <small class="field-note">Carga módulos según el programa elegido.</small>
          </v-col>

          <v-col cols="12">
            <v-autocomplete
              v-model="form.moduloId"
              :items="modulos"
              item-text="nombre"
              item-value="id"
              label="Módulo"
              dense
              outlined
              hide-details
              clearable
              :loading="cargandoModulos" />
            <small class="field-note">Solo se muestran módulos del programa seleccionado.</small>
          </v-col>

          <v-col cols="12" md="6" lg="4">
            <v-select
              v-model="form.estado"
              :items="estadosSelect"
              label="Estado"
              dense
              outlined
              hide-details />
            <small class="field-note">Selecciona el estado de la solicitud.</small>
          </v-col>

          <v-col cols="12" md="6" lg="4">
            <v-text-field
              v-model="form.fechaInicio"
              type="date"
              label="Fecha inicio"
              dense
              outlined
              hide-details />
            <small class="field-note">Incluye solicitudes desde esta fecha.</small>
          </v-col>

          <v-col cols="12" md="6" lg="4">
            <v-text-field
              v-model="form.fechaFin"
              type="date"
              label="Fecha fin"
              dense
              outlined
              hide-details />
            <small class="field-note">Incluye solicitudes hasta esta fecha.</small>
          </v-col>

        </v-row>
      </v-card-text>
      <v-divider class="mt-1"></v-divider>
      <v-card-actions class="pt-3 pb-4 px-4">
        <v-spacer></v-spacer>
        <v-btn text small @click="cerrar">Cancelar</v-btn>
        <v-btn color="primary" small @click="aplicar">
          <v-icon left small>mdi-check</v-icon>
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogFiltroSolicitud',
  props: {
    programas: {
      type: Array,
      default: () => [],
    },
    modulos: {
      type: Array,
      default: () => [],
    },
    estadosSelect: {
      type: Array,
      default: () => [],
    },
    cargandoProgramas: {
      type: Boolean,
      default: false,
    },
    cargandoModulos: {
      type: Boolean,
      default: false,
    },
    filtrosIniciales: {
      type: Object,
      default: () => ({
        programaId: null,
        moduloId: null,
        estado: null,
        gestion: null,
        fechaInicio: null,
        fechaFin: null,
        busqueda: null,
      }),
    },
  },
  data() {
    return {
      dialog: false,
      form: { ...this.filtrosIniciales },
    };
  },
  computed: {
    gestionesOptions() {
      const current = new Date().getFullYear();
      return Array.from({ length: 7 }, (_item, index) => current + 1 - index);
    },
  },
  watch: {
    filtrosIniciales(val) {
      this.form = { ...val };
    },
  },
  methods: {
    abrir(filtros = {}) {
      this.form = { ...this.filtrosIniciales, ...filtros };
      this.dialog = true;
    },
    onProgramaChange(programaId) {
      this.form.moduloId = null;
      this.$emit('cargar-modulos', programaId);
    },
    aplicar() {
      this.$emit('aplicar', { ...this.form });
      this.dialog = false;
    },
    cerrar() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.title {
  font-weight: 600;
}

.muted {
  color: #6a6f7a;
}

.dialog-card {
  border-radius: 10px;
}

.field-note {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #7d8894;
}
</style>